/* Gift with purchase: keeps the free gift quantity equal to the number of items in the cart (capped).
   - A BYOB kit (scent lines sharing one _byob_kit code) counts as 1; add-ons and other products count per unit.
   - Excluded products, $0 lines and the gift itself don't count.
   - Re-checks after every cart change made through fetch (theme drawer, cart page, BYOB page) and on page load.
   Config comes from sections/gift-with-purchase.liquid. */
(() => {
  const el = document.getElementById('gwp-config');
  if (!el || window.__gwp) return;
  window.__gwp = true;
  const cfg = JSON.parse(el.textContent);
  // Schedule: "YYYY-MM-DD HH:MM" in the store's time zone (cfg.tz, e.g. "+0800")
  const tz = /^[+-]\d{4}$/.test(cfg.tz || '') ? cfg.tz.slice(0, 3) + ':' + cfg.tz.slice(3) : 'Z';
  const parseTime = (s) => {
    const m = /^(\d{4}-\d{2}-\d{2})[ T](\d{1,2}):(\d{2})$/.exec(s || '');
    if (!m) return s ? NaN : null;
    return Date.parse(`${m[1]}T${m[2].padStart(2, '0')}:${m[3]}:00${tz}`);
  };
  const start = parseTime(cfg.start);
  const end = parseTime(cfg.end);
  const badSchedule = Number.isNaN(start) || Number.isNaN(end);
  let preview = false;
  // Preview: ?gwp_preview=1 runs the rule for this browser session only, ignoring the schedule (?gwp_preview=0 stops it)
  try {
    const q = new URLSearchParams(window.location.search).get('gwp_preview');
    if (q !== null) sessionStorage.setItem('gwp_preview', q);
    preview = sessionStorage.getItem('gwp_preview') === '1';
  } catch (e) {}
  const active = () => {
    if (preview) return true;
    if (!cfg.enabled || badSchedule) return false;
    const now = Date.now();
    return (start == null || now >= start) && (end == null || now < end);
  };
  if (badSchedule && window.Shopify && window.Shopify.designMode) {
    const p = document.createElement('p');
    p.style.cssText = 'position:fixed;bottom:12px;left:12px;z-index:9999;margin:0;padding:8px 12px;background:#b00020;color:#fff;font-size:13px;border-radius:4px';
    p.textContent = 'Gift with purchase: schedule time not understood. Use YYYY-MM-DD HH:MM, e.g. 2026-12-01 00:00. Gifts are paused until fixed.';
    document.body.appendChild(p);
  }
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECTION = 'minicart-form';
  const nativeFetch = window.fetch.bind(window);
  const isCartWrite = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  let timer, busy = false, again = false;

  // Our own requests use nativeFetch, so they never re-trigger a sync.
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const res = nativeFetch(input, init);
    if (isCartWrite(url)) res.then(schedule, () => {});
    return res;
  };

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 300);
  }

  const post = (url, body) =>
    nativeFetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json().then((data) => (r.ok ? data : Promise.reject(data))));

  function wanted(cart) {
    if (!active()) return 0;
    const kits = new Set();
    let count = 0;
    cart.items.forEach((item) => {
      if (item.variant_id === cfg.giftVariant || item.product_id === cfg.giftProduct) return;
      if (cfg.exclude.includes(item.product_id) || item.original_price === 0) return;
      const props = item.properties || {};
      if (props._byob_kit && props._byob_part !== 'addon') kits.add(props._byob_kit);
      else count += item.quantity;
    });
    return Math.min(cfg.max, count + kits.size);
  }

  async function sync() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      const cart = await nativeFetch(root + 'cart.js').then((r) => r.json());
      const gifts = cart.items.filter((i) => i.variant_id === cfg.giftVariant);
      const have = gifts.reduce((n, i) => n + i.quantity, 0);
      const want = wanted(cart);
      if (have === want && gifts.length <= 1) return;

      let data;
      if (gifts.length) {
        // Keep one gift line at the right quantity, clear any extras
        const updates = {};
        gifts.forEach((g, idx) => { updates[g.key] = idx === 0 ? want : 0; });
        data = await post('cart/update.js', { updates, sections: SECTION });
      } else {
        data = await post('cart/add.js', {
          items: [{ id: cfg.giftVariant, quantity: want, properties: { Offer: cfg.label, _gwp: '1' } }],
          sections: SECTION,
        });
      }

      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      } else if (window.BYOBCart) {
        await window.BYOBCart.refresh(data.sections);
      }
    } catch (e) {
      // Gift out of stock or unavailable: leave the cart as it is
    } finally {
      busy = false;
      if (again) { again = false; schedule(); }
    }
  }

  const count = document.querySelector('.cart-count');
  if (!count || count.textContent.trim() !== '0') sync();

  // If the page stays open across the start or end time, re-check the cart then
  [start, end].forEach((t) => {
    const wait = t - Date.now();
    if (wait > 0 && wait < 864e5) setTimeout(schedule, wait + 1000);
  });
})();
